import React from "react";
import "./Education.css";
import Navbar from "../components/Navbar";

const HospitalityAndInnovation = () => {
  return (
    <>
      <Navbar />
      <div className="energyInfra-container">
        <div className="energyInfra-content">
          {/* Hospitality & Tourism Section */}
          <p className="para">Industries / Hospitality & Tourism</p>
          <h2>Hospitality & Tourism</h2>
          <p className="subtitle1">
            Reimagining Guest Experiences with Immersive Technologies
          </p>
          <p>
            At Spatial Computing Technologies (SpatialCT), we help hospitality brands embrace XR (Extended Reality) to create unforgettable guest experiences, optimize operations, and stand out in a competitive market. From immersive hotel previews to spatial training for staff, our solutions elevate both customer engagement and backend efficiency.
          </p>

          <div className="energyInfra-grid">
            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Immersive Hotel & Resort Previews</h4>
                <p>Enable potential guests to virtually explore rooms, suites, spas, and amenities before booking.</p>
                <ul>
                  <li>360° walkthroughs and interactive room selection</li>
                  <li>WebVR compatibility—no app download required</li>
                  <li>Custom branding and seasonal campaign integration</li>
                </ul>
                <p><strong>Ideal for:</strong> Hotels, resorts, travel aggregators</p>
              </div>

              <div className="energyInfra-box">
                <h4>Staff Training in XR</h4>
                <p>Train staff in customer service, housekeeping, kitchen hygiene, and crisis management using immersive scenarios.</p>
                <ul>
                  <li>Real-world role-playing simulations in VR</li>
                  <li>Multilingual voiceover support</li>
                  <li>Trackable assessments and safety compliance</li>
                </ul>
                <p><strong>Ideal for:</strong> Hotel chains, training consultancies, HR departments</p>
              </div>
            </div>

            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Virtual Destination Exploration</h4>
                <p>Offer tourists a preview of destinations, cultural landmarks, and experiences through immersive storytelling.</p>
                <ul>
                  <li>AR city guides, heritage site exploration</li>
                  <li>VR-based booking assistance integrated with travel portals</li>
                  <li>Multi-location travel previews</li>
                </ul>
                <p><strong>Ideal for:</strong> Tourism boards, travel agencies, tour operators</p>
              </div>

              <div className="energyInfra-box">
                <h4>AR Guest Engagement & Way finding</h4>
                <p>Use augmented reality to guide guests within the hotel and provide interactive digital concierge services.</p>
                <ul>
                  <li>Indoor AR navigation, restaurant menus, pool schedules</li>
                  <li>Contactless service requests through AR QR codes</li>
                  <li>Multi-language support for global guests</li>
                </ul>
                <p><strong>Ideal for:</strong> Smart hotels, boutique chains, resorts</p>
              </div>
            </div>

            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Experience Centers & Brand Storytelling in XR</h4>
                <p>Create permanent or pop-up XR brand experiences to emotionally connect with your audience.</p>
                <ul>
                  <li>VR lounges, brand heritage storytelling, immersive booking zones</li>
                  <li>Event-based guest engagement (weddings, expos, fairs)</li>
                  <li>Integration with CRM and loyalty platforms</li>
                </ul>
                <p><strong>Ideal for:</strong> Luxury hotel chains, heritage properties, marketing teams</p>
              </div>
            </div>
          </div>

          {/* Use Cases Table */}
          <div className="usecases1-section">
            <h3>Use Cases At a Glance</h3>
            <div className="usecases1-table">
              <div className="usecases1-row usecases1-header">
                <div>Use Case</div>
                <div>Application</div>
                <div>Benefit</div>
              </div>
              <div className="usecases1-row">
                <div>Virtual Tours</div>
                <div>Guest booking</div>
                <div>Better conversion, reduced cancellations</div>
              </div>
              <div className="usecases1-row">
                <div>Staff Training</div>
                <div>SOP, safety, soft skills</div>
                <div>Faster, consistent training</div>
              </div>
              <div className="usecases1-row">
                <div>Guest Engagement</div>
                <div>Navigation, concierge</div>
                <div>Enhanced experience, fewer service calls</div>
              </div>
              <div className="usecases1-row">
                <div>Travel Marketing</div>
                <div>Destination previews</div>
                <div>Inspire & convert high-value travellers</div>
              </div>
              <div className="usecases1-row">
                <div>Event Showcases</div>
                <div>Wedding/Expo demos</div>
                <div>Close clients before site visits</div>
              </div>
            </div>

            <div className="usecases1-cta">
              <h4>Partner with Us</h4>
              <p>
                Let us bring immersive value to your guests and your brand. Whether you’re looking to onboard staff quickly or create stunning virtual walkthroughs, SpatialCT delivers tailor-made solutions for the hospitality industry.
              </p>
              <p>
                <b>Contact us</b> to co-create memorable spatial experiences that enhance loyalty, efficiency, and delight.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HospitalityAndInnovation;
